export const AKT_COOKIE_KEY = 'searchPaymentFilters';
